import axios from 'axios'
import isEmpty from 'lodash-es/isEmpty'
import GetCookie from '../globalHeader/common/getCookie'
import { tokenCookieKey } from '../globalHeader/functions/ams-functions'
import { getRuntimeEnv } from '../utils/runtimeEnv'

export const getPopupApiUrl = (): string => {
    const runtimeUrl = getRuntimeEnv('VITE_REACT_APP_POPUP_URL')
    if (runtimeUrl) return runtimeUrl
    // ts-ignore needed for next.js app
    // @ts-ignore
    if (!isEmpty(import.meta) && import.meta.env.VITE_REACT_APP_POPUP_URL) {
        // @ts-ignore
        return import.meta.env.VITE_REACT_APP_POPUP_URL
    } else if (process.env.NEXT_PUBLIC_POPUP_URL) {
        return process.env.NEXT_PUBLIC_POPUP_URL
    } else {
        throw new Error('API URL is not defined')
    }
}

export const popupAPI = axios.create({
    baseURL: getPopupApiUrl(),
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
})

// Add a request interceptor
popupAPI.interceptors.request.use(
    async (config) => {
        // Bearer as well as the cookie: WebViews and cookie-blocking browsers may not deliver the jwt cookie here
        const token = GetCookie(tokenCookieKey)
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

// Add a response interceptor
popupAPI.interceptors.response.use(
    (response) => response,
    async (error) => {
        // A 401 goes back to the caller untouched: renewToken() deletes the jwt cookie when it fails,
        // so calling it from here would turn a popup 401 into a lost session
        return Promise.reject(error)
    },
)
